import { render, staticRenderFns } from "./CollegeSubscriptions.vue?vue&type=template&id=46379012"
import script from "./CollegeSubscriptions.vue?vue&type=script&lang=js"
export * from "./CollegeSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports